import cx from 'classix'
import React, { useState } from 'react'

import HoverableArrow from '@components/navigation/HoverableArrow'

type Props = {
  href: string
  className?: string
  text: string
  arrowOpen?: boolean
  children?: React.ReactNode
}

export default function HoverableArrowLink({
  href,
  className,
  text,
  children,
  arrowOpen = false,
}: Props) {
  const [hovered, setHovered] = useState(false)

  return (
    <a
      className='group'
      href={href}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span className={cx('group-hover:underline', className)}>
        <HoverableArrow text={text} showArrow={arrowOpen || hovered} />
      </span>
      {children}
    </a>
  )
}
